//
// Search Filter Submit...
//
// Disables and submits the form on filter select
// ---------------------------------------------------------------------------

'use strict';

const config = {
    form: '.js-search-filter-form',
    mobileForm: '.js-search-filter-form-mobile',
    target: '.js-search-filter',
    filter: ':checkbox'
};

let form = $(config.form);
let filters = form.find(config.filter);

$('body').on('change', filters, function() {
    let mobileForm = $(config.mobileForm);

    if (mobileForm.length > 0) {
        handleCheckboxes(mobileForm);
    } else {
        handleCheckboxes(form);
    }
});


//Submit form on change and lock other checkboxes to avoid multi select before form is submitted
function handleCheckboxes(form) {
    // Disable checkboxes
    form.find(config.filter).prop('disabled', true);

    // Clone fields for checked items and add them as hidden fields to ensure values are submitted
    form.find(config.filter).each(function() {
        if ($(this).is(':checked')) {
            // Add hidden fields so values are still submitted if checked
            let hiddenInput = $(this).clone()
                .prop('type', 'hidden')
                .prop('disabled', false)
                .prop('id', function(i, val) {
                    return 'hidden_' + val;
                });

            form.append(hiddenInput);
        }
    });

    form.submit();
}



// WEBPACK FOOTER //
// ./src/js/components/search-filter-submit.js